<p-confirmDialog></p-confirmDialog>

<form [formGroup]="formProfile" class="grid grid-cols-12 gap-3 w-full">
  <!-- Nombre -->
  <div class="col-span-12 md:col-span-6">
    <div class="flex flex-col gap-2">
      <label for="firstName">Nombre <span class="text-red-500">*</span></label>
      <input pInputText id="firstName" type="text" class="w-full" formControlName="firstName" [autocomplete]="false" />
      <small class="p-error" *ngIf="formProfile.get('firstName')?.invalid && formProfile.get('firstName')?.touched">
        {{ getErrorMessage('firstName') }}
      </small>
    </div>
  </div>

  <!-- Apellido -->
  <div class="col-span-12 md:col-span-6">
    <div class="flex flex-col gap-2">
      <label for="lastName">Apellido <span class="text-red-500">*</span></label>
      <input pInputText id="lastName" type="text" class="w-full" formControlName="lastName" [autocomplete]="false" />
      <small class="p-error" *ngIf="formProfile.get('lastName')?.invalid && formProfile.get('lastName')?.touched">
        {{ getErrorMessage('lastName') }}
      </small>
    </div>
  </div>

  <!-- Correo Electrónico -->
  <div class="col-span-12">
    <div class="flex flex-col gap-2">
      <label for="email">Correo Electrónico <span class="text-red-500">*</span></label>
      <input pInputText id="email" type="email" class="w-full" formControlName="email" [autocomplete]="false" />
      <small class="p-error" *ngIf="formProfile.get('email')?.invalid && formProfile.get('email')?.touched">
        {{ getErrorMessage('email') }}
      </small>
    </div>
  </div>

  <!-- Modo de contraseña temporal (solo creación) -->
  <div class="col-span-12" *ngIf="isNew">
    <div class="flex flex-col gap-2">
      <label for="tempPasswordMode">Modo de Contraseña Temporal <span class="text-red-500">*</span></label>
      <p-select
        id="tempPasswordMode"
        [options]="[
          { label: 'Generada aleatoriamente (recomendado)', value: 'random' },
          { label: 'Definir contraseña personalizada', value: 'custom' },
        ]"
        formControlName="tempPasswordMode"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleccione un modo"
        appendTo="body"
      ></p-select>
    </div>
  </div>

  <!-- Contraseña personalizada (si custom) -->
  <div class="col-span-12" *ngIf="isNew && formProfile.get('tempPasswordMode')?.value === 'custom'">
    <div class="flex flex-col gap-2">
      <label for="password">Contraseña Temporal <span class="text-red-500">*</span></label>
      <div class="flex gap-2">
        <input pInputText id="password" [type]="showPassword ? 'text' : 'password'" class="flex-1" formControlName="password" [autocomplete]="false" />
        <p-button icon="pi pi-eye" [outlined]="true" [text]="true" [rounded]="true" (click)="toggleShowPassword()"></p-button>
      </div>
      <small class="p-error" *ngIf="formProfile.get('password')?.invalid && formProfile.get('password')?.touched">
        {{ getErrorMessage('password') }}
      </small>
      <small class="text-xs">Debe incluir: número, mayúscula, minúscula y símbolo (8-16 caracteres)</small>
    </div>
  </div>

  <!-- Permisos en la organización -->
  <div class="col-span-12">
    <hr class="my-1" />
    <div class="flex flex-col gap-1 mb-2">
      <span class="font-bold">Permisos en la organización</span>
      <small class="text-color-secondary" *ngIf="organizationName">{{ organizationName }}</small>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-[1fr_minmax(200px,260px)] gap-3 items-end mb-3">
      <div class="flex flex-col gap-1">
        <label class="font-medium">¿El usuario será Administrador de Organización?</label>
        <small class="text-color-secondary">
          Si responde que sí, se asignará administración completa de la organización y de todos los productos contratados.
        </small>
      </div>
      <p-select
        [options]="orgAdminOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="isOrgAdmin"
        [ngModelOptions]="{ standalone: true }"
        appendTo="body"
        styleClass="w-full"
        (onChange)="onOrgAdminModeChange($event.value)"
      ></p-select>
    </div>

    <div *ngIf="isOrgAdmin" class="text-sm text-color-secondary border-round p-3 bg-surface-100">
      Se asignará el rol <strong>Administrador de la Organización</strong> y <strong>Administrador de Producto</strong> en todos los productos contratados.
    </div>

    <div *ngIf="!isOrgAdmin && contractedServices.length === 0" class="text-color-secondary text-sm py-1">
      La organización no tiene productos contratados para asignar a este usuario.
    </div>

    <p-table *ngIf="!isOrgAdmin && contractedServices.length > 0" [value]="contractedServices" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th>Producto contratado</th>
          <th style="width: 16rem">Rol del usuario</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-service>
        <tr>
          <td>
            <div class="flex flex-col gap-1">
              <span class="font-medium">{{ getServiceDisplayLabel(service) }}</span>
              <small class="text-color-secondary">{{ service }}</small>
            </div>
          </td>
          <td>
            <p-select
              [options]="serviceBundleOptions[service]"
              optionLabel="bundleLabel"
              optionValue="bundleId"
              [(ngModel)]="selectedServiceBundle[service]"
              [ngModelOptions]="{ standalone: true }"
              appendTo="body"
              styleClass="w-full"
            >
              <ng-template let-item pTemplate="item">
                <div class="flex flex-col">
                  <span>{{ item.bundleLabel }}</span>
                  <small class="text-color-secondary" *ngIf="item.bundleDescription">{{ item.bundleDescription }}</small>
                </div>
              </ng-template>
            </p-select>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</form>

<div class="dialog-actions flex justify-end gap-2 mt-3">
  <p-button label="Cancelar" severity="danger" [text]="true" [disabled]="isLoading" (click)="hideDialog()"></p-button>
  <p-button
    [label]="isNew ? 'Crear Usuario' : 'Actualizar Usuario'"
    severity="success"
    [loading]="isLoading"
    [disabled]="!isFormValid"
    (click)="saveConfiguration()"
  ></p-button>
</div>
